import { Facebook, Instagram, Youtube, MapPin, Phone, Mail } from "lucide-react";
import { CLINIC } from "../lib/clinic";

export const Footer = () => {
  const year = new Date().getFullYear();
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer
      data-testid="footer"
      className="relative bg-[#0f2b28] text-white pt-20 pb-8 overflow-hidden"
    >
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-[#009688]/20 rounded-full blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-[#009688] to-[#00796b] grid place-items-center shadow-lg">
                <svg viewBox="0 0 24 24" fill="none" className="w-6 h-6">
                  <path
                    d="M12 3c-2.5 0-3.5 1-5 1-2 0-3.5 1.5-3.5 5 0 3 1 6 2 8s1.5 4 3 4 1.5-4 3.5-4 2 4 3.5 4 2-2 3-4 2-5 2-8c0-3.5-1.5-5-3.5-5-1.5 0-2.5-1-5-1z"
                    fill="white"
                  />
                </svg>
              </div>
              <div>
                <div className="text-xl font-bold font-[Outfit]">Abhayam Dental Clinic</div>
                <div className="text-sm font-malayalam text-[#4FC3F7]">
                  {CLINIC.nameMl}
                </div>
              </div>
            </div>
            <p className="mt-5 text-sm text-white/60 leading-relaxed max-w-md">
              Providing high-quality, pain-free dental care with modern
              equipment and experienced professionals in Manjeri, Kerala.
            </p>

            <div className="mt-6 flex items-center gap-3">
              {[Facebook, Instagram, Youtube].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  data-testid={`footer-social-${i}`}
                  aria-label="Social link"
                  className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#009688] grid place-items-center transition-colors"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-wider text-white/50 font-semibold">
              Quick Links
            </div>
            <ul className="mt-4 space-y-2.5">
              {[
                ["about", "About Us"],
                ["services", "Services"],
                ["doctors", "Doctors"],
                ["reviews", "Reviews"],
                ["appointment", "Book Now"],
              ].map(([id, label]) => (
                <li key={id}>
                  <button
                    onClick={() => go(id)}
                    data-testid={`footer-link-${id}`}
                    className="text-sm text-white/70 hover:text-white hover:translate-x-0.5 inline-block transition-all"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-wider text-white/50 font-semibold">
              Reach Us
            </div>
            <ul className="mt-4 space-y-3">
              <li className="flex items-start gap-3 text-sm text-white/75">
                <MapPin className="w-4 h-4 text-[#4FC3F7] shrink-0 mt-0.5" />
                {CLINIC.address.full}
              </li>
              <li className="flex items-center gap-3 text-sm text-white/75">
                <Phone className="w-4 h-4 text-[#4FC3F7]" />
                <a href={`tel:${CLINIC.phoneRaw}`} className="hover:text-white">
                  {CLINIC.phone}
                </a>
              </li>
              <li className="flex items-center gap-3 text-sm text-white/75">
                <Mail className="w-4 h-4 text-[#4FC3F7]" />
                Mon – Sat · 9:30 AM – 7:00 PM
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="text-xs text-white/50">
            © {year} Abhayam Dental Clinic. All rights reserved.
          </div>
          <div className="text-xs text-white/50">
            Powered by <a href="https://www.v-nexus.com" className="hover:text-white">V-Nexus</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
